export interface UserLegalDocument {
  party_id: string;
  type: LEGAL_DOCUMENT_TYPE;
  version: number;
  created_at: string;
}
export interface LegalDocument {
  type: LEGAL_DOCUMENT_TYPE;
  version: number;
  uri: string;
  is_mandatory: boolean;
  created_at: string;
  markdown_uri?: string;
}

export enum LEGAL_DOCUMENT_TYPE {
  directDebitCancellationTermsAndConditions = 'direct_debit_cancellation_terms_and_conditions',
  directDebitGeneralConditions = 'direct_debit_general_conditions',
  directDebitRegistrationTermsAndConditions = 'direct_debit_registration_terms_and_conditions',
  executionService = 'execution_service',
  generalFrameworkAction = 'general_framework_action',
  openingBlackPersonalIdDataVerification = 'opening_black_personal_id_data_verification',
  openingUserActsOnHisOwn = 'opening_user_acts_on_his_own',
  openingUserOwnResources = 'opening_user_own_resources',
  personalIdDataVerification = 'personal_id_data_verification',
  portfolioChangeAcceptance = 'portfolio_change_acceptance',
  statementOfCorrectDrivewealthInformation = 'statement_of_correct_drivewealth_information',
  termsAndConditions = 'terms_and_conditions',
  tradingUsaExecutionService = 'trading_usa_execution_service',
  tradingUsaNoticeOfPrivacy = 'trading_usa_notice_of_privacy',
  tradingUsaTermsAndConditions = 'trading_usa_terms_and_conditions',
}
